<template>
  <DashboardContextHeader v-if="scope === RoleScope.SINGLE_CANTEEN" :title="title" v-on="$listeners">
    <template #extra><slot name="extra" /></template>
  </DashboardContextHeader>
  <MultiCanteenContextHeader v-else-if="scope === RoleScope.MULTI_CANTEEN" :title="title" :job="job" v-on="$listeners">
    <template #extra><slot name="extra" /></template>
  </MultiCanteenContextHeader>
  <p v-else class="scope-error" role="alert">
    Portée indéterminée pour le rôle « {{ job }} » : aucun en-tête ne peut être affiché.
  </p>
</template>

<script>
import DashboardContextHeader from "./DashboardContextHeader.vue"
import MultiCanteenContextHeader from "./MultiCanteenContextHeader.vue"
import { RoleScope, scopeOf } from "@/scopeByJob"

/**
 * Point unique de choix entre les deux en-têtes de dashboard, d'après `SCOPE_BY_JOB` (S6,
 * requirement « Le choix de l'en-tête découle de la portée déclarée »). Une vue de dashboard
 * monte `DashboardHeader` avec son `job` et n'a plus à savoir laquelle des deux portées
 * s'applique : si `SCOPE_BY_JOB` change, ce composant change de rendu sans qu'aucune vue ne soit
 * touchée.
 */
export default {
  name: "DashboardHeader",

  components: { DashboardContextHeader, MultiCanteenContextHeader },

  props: {
    title: {
      type: String,
      required: true,
    },
    // Rôle du dashboard (ex. "COOK", "SUPERVISOR"). Détermine la portée via `SCOPE_BY_JOB`.
    job: {
      type: String,
      required: true,
    },
  },

  data() {
    return { RoleScope }
  },

  computed: {
    scope() {
      return scopeOf(this.job)
    },
  },
}
</script>

<style scoped>
.scope-error {
  color: #991b1b;
  text-align: center;
  font-weight: 600;
}
</style>
